import React from 'react';
import { useTranslations } from '../../locales/useTranslations';

const KontaktHeader = () => {
    const { t } = useTranslations();
    return (
        <div className="mainbanner kontakt-header">
            {/* Subtile Hintergrund-Elemente */}
            <div className="kontakt-header__decoration kontakt-header__decoration--top-right"></div>
            <div className="kontakt-header__decoration kontakt-header__decoration--bottom-left"></div>

            <section className="services-area ptb-100 kontakt-header__content">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-12">
                            <div className="services-content it-service-content text-center">
                                <div className="content">
                                    <div className="kontakt-header__badge">
                                        {t('contact_header_upperTitle')}
                                    </div>

                                    <h1 className="kontakt-header__title">
                                        {t('contact_header_title')}
                                    </h1>

                                    <p className="kontakt-header__description">
                                        {t('contact_header_description')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default KontaktHeader;
